import { useAppSelector } from "../../app/hooks";
import Success from "./Success";
import Error from "./Error";
import SendingRequest from "./SendingRequest";
import FailedPayment from "./FailedPayment";
import { Fragment } from "react";
import { Redirect } from "react-router-dom";
import Navbar from "../../layout/Navigation/Navbar";

const PurchaseResult = () => {
    const loading = useAppSelector(state => state.voucher.status.isLoading);
    const chosenGuid = useAppSelector(state => state.voucher.chosenGuid);
    const status = useAppSelector(state => state.voucher.status.result.type);
    const errorMessage = useAppSelector(
        state => state.voucher.status.result.description
    );

    const success = status === "success";
    const error = status === "error";
    const failedPayment = status === "failed-payment";

    if (!chosenGuid.guid) return <Redirect to={"/"} />;

    return (
        <Fragment>
            {!loading && <Navbar />}
            <section className={`container ${!loading && "first-section"}`}>
                <div className="purchase-container">
                    {loading && <SendingRequest />}
                    {success && <Success />}
                    {error && <Error message={errorMessage} />}
                    {failedPayment && <FailedPayment />}
                </div>
            </section>
        </Fragment>
    );
};

export default PurchaseResult;
